module.exports = __webpack_public_path__ + "assets/images/read-more_bab760abeff101e9569c93399b6004e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-six/read-more.png
// module id = 226
// module chunks = 0